export default {"id":"3ffbe0fe","attrs":{"viewBox":"0 0 18 18","width":"18","height":"18"}}